/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisteredClientIp
 */
export interface RegisteredClientIp {
    /**
     * 
     * @type {string}
     * @memberof RegisteredClientIp
     */
    ip: string;
}

/**
 * Check if a given object implements the RegisteredClientIp interface.
 */
export function instanceOfRegisteredClientIp(value: object): value is RegisteredClientIp {
    if (!('ip' in value) || value['ip'] === undefined) return false;
    return true;
}

export function RegisteredClientIpFromJSON(json: any): RegisteredClientIp {
    return RegisteredClientIpFromJSONTyped(json, false);
}

export function RegisteredClientIpFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisteredClientIp {
    if (json == null) {
        return json;
    }
    return {
        
        'ip': json['ip'],
    };
}

export function RegisteredClientIpToJSON(json: any): RegisteredClientIp {
    return RegisteredClientIpToJSONTyped(json, false);
}

export function RegisteredClientIpToJSONTyped(value?: RegisteredClientIp | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ip': value['ip'],
    };
}

